<template>
    <div class="wrapper">
        <div class="page-idea-fx">
            <h2>
                Настройки группы - <span v-if="group">{{ group.title }}</span>
            </h2>
            <div class="wrap-content" style="margin-bottom: 25px">
                <button @click="createInviteLink" type="button" class="btn btn--large">
                    <span>Создать ссылку</span>
                </button>

                <!--               A: {{ this.group.id ?? '' }} ,  B: {{ this.$route.params.id ?? ''}}-->

                <h3>Ссылки-приглашения</h3>

                <table class="table-typical">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>Название</th>
                            <th>Вступлений</th>
                            <th>Статус</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in links" :key="index" class="table-typical__tablet-tooltip-more">
                            <td data-ttl="Название:" style="cursor: pointer" class="table-typical__mobile-td">
                                {{ item.id }}
                            </td>
                            <td
                                @click="openInviteLinkModal(item.id)"
                                data-ttl="Название:"
                                style="cursor: pointer"
                                class="table-typical__mobile-td"
                            >
                                {{ item.title }}
                            </td>
                            <td data-ttl="Название:" class="table-typical__mobile-td">
                                {{ getLimitLabel(item) }}
                            </td>
                            <td data-ttl="Название:" class="table-typical__mobile-td">
                                {{ item.status }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>

<script>
import VButton from "../../../common/components/VButton";
import { apiUser } from "../apiUser";
import PlOrdersTab from "../../forex/components/PlOrdersTab";

export default {
    name: "TgRefUserChatPage",
    $_veeValidate: {
        validator: "new"
    },
    components: {
        PlOrdersTab,
        VButton
    },
    data() {
        return {
            links: [],
            group: null
        };
    },
    created() {
        this.init();
    },
    computed: {},
    methods: {
        getGroupData() {
            apiUser.getGroupById(this.$route.params.id).then(data => {
                this.group = data.data;
            });
        },
        getLimitLabel(item) {
            return item.limit !== null ? `${item.inviteCount} из ${item.limit}` : "---";
        },
        init() {
            this.getGroupData();
            apiUser.getGroupInviteLinks(`user`, this.$route.params.id).then(data => {
                this.links = data.data;
            });
        },
        openInviteLinkModal(id) {
            this.openModal("InviteLink", { id: id, groupId: this.$route.params.id })
                .then(() => {})
                .then(() => {})
                .finally(() => {
                    this.init();
                });
        },
        createInviteLink() {
            this.openModal("CreateInviteLink", { from: "ideafx" })
                .then(data => {
                    this.openInviteLinkModal(data.id);
                })
                .then(() => {})
                .then(() => {})
                .finally(() => {});
        }
    }
};
</script>

<style lang="scss" scoped>
.wrapper {
    padding: 0 12px;
    @media (min-width: 520px) {
        padding-left: 30px;
        padding-right: 30px;
    }
    @media (min-width: 769px) {
        padding: 40px 60px;
    }
}

.page-idea-fx {
    h1 {
        font-weight: bold;
        font-size: 32px;
        line-height: 40px;
        color: #1d2228;
    }

    p {
        font-size: 14px;
        line-height: 24px;
        color: #58606e;
    }

    .wrap-content {
        max-width: 600px;
        width: 100%;
    }

    .form-group {
        max-width: 300px;
    }
}
</style>
